export const EXTERNAL_ORIGINS = [
    'http://localhost:3000',
    'https://pr.odyzeo.dev',
];
